var exports = {
  "Qs": "content__pcXsAq",
  "wx": "header__DnPR4Y",
  "qV": "skeleton__7WMkza",
};

module.exports = exports;
